import { Inject, Injectable } from '@angular/core'
import { firstValueFrom } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { APP_CONFIG } from 'src/app/app.config'
import { AppConfigModel } from 'src/app/core/models'
import { SignReport } from '../models/sign-report.model'

export { SignReport } from '../models/sign-report.model'

@Injectable({
  providedIn: 'root',
})
export class CustomerReportingService {
  constructor(
    private readonly http: HttpClient,
    @Inject(APP_CONFIG) private readonly config: AppConfigModel,
  ) {}

  public async submitReport(report: SignReport): Promise<{ ticketKey: string; ticketUrl: string }> {
    const response = await firstValueFrom(
      this.http.post<{ ticketKey: string; ticketUrl: string }>(
        `${this.config.backend_url}vzo/report`,
        report,
      ),
    )
    return response
  }
}
